<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       data-url="aafb/invoice/"
                       data-key="invoices"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.invoice_no="{item}">
      {{ `PO${item.purchase_order.id.toString().padStart(8, "0")}/${item.invoice_no}` }}
    </template>
    <template #item.issued_at="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template #item.due_at="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template #item.amount="{value}">
      {{ parseInt(value) / 100.0 }}
    </template>
    <template #item.status="{value}">
      {{ $t(`invoice_status.${value}`) }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <a :href="`${HOST}static/${item.pdf}`" target="_blank">
            <v-btn icon
                   v-on="on"
                   v-bind="attrs">
              <v-icon>mdi-file-download</v-icon>
            </v-btn>
          </a>
        </template>
        <span>{{ $t('invoice.download_pdf') }}</span>
      </v-tooltip>

      <v-tooltip top
                 v-if="item.status === 'AWAITING_PAYMENT' || item.status === 'PENDING_CONFIRMATION'">
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="payItem(item)">
            <v-icon>mdi-currency-usd</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('invoice.pay') }}</span>
      </v-tooltip>

      <v-tooltip top
                 v-if="item.status === 'SETTLED'">
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="showItem(item)">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('invoice.summary') }}</span>
      </v-tooltip>
    </template>
  </RemotePaginatedList>
</template>


<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {HOST} from "@/main";

export default {
  name: 'InvoiceList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    extraParams: Object,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        // {text: root.$t('admin_acc_invoice.invoice_no'), value: 'full_invoice_no', contains: true},
        // {text: root.$t('admin_acc_purchase_order.recipient_hkiarace_no'), value: 'purchase_order.recipient.hkiarace_acconut.id'},
        // {text: root.$t('admin_acc_invoice.title'), value: 'title', contains: true},
        // {
        //   text: root.$t('admin_acc_invoice.status'), value: 'status',
        //   options: [
        //     {text: 'DRAFT', value: 'DRAFT'},
        //     {text: 'CONFIRMED', value: 'CONFIRMED'},
        //     {text: 'SETTLED', value: 'SETTLED'},
        //   ],
        // },
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_invoice.invoice_no'), value: 'full_invoice_no'},
      {text: root.$t('admin_acc_invoice.issued_at'), value: 'issued_at'},
      {text: root.$t('admin_acc_invoice.due_at'), value: 'due_at'},
      {text: root.$t('admin_acc_invoice.title'), value: 'title', sortable: false},
      {text: root.$t('admin_acc_invoice.amount'), value: 'amount', sortable: false},
      {text: root.$t('admin_acc_invoice.status'), value: 'status', sortable: false},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);


    const showItem = function (item) {
      root.$router.push({name: 'invoice-pay-success', params: {invoiceId: item.id}})
    }
    const payItem = function (item) {
      root.$router.push({name: 'invoice-pay', params: {invoiceId: item.id}})
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      HOST,
      showItem,
      payItem,
    }
  }
}
</script>
